"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
exports.test = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.object.keys.js");
var _fromPairs2 = _interopRequireDefault(require("lodash/fromPairs"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function cov_1tny8dqku7() {
  var path = "/__w/code/code/js/packages/bricks/src/helpers/imgixUrl.ts";
  var hash = "fac013852322e93fc74e2aab37860136a9adb41c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/helpers/imgixUrl.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 20
        },
        end: {
          line: 3,
          column: 47
        }
      },
      "1": {
        start: {
          line: 7,
          column: 45
        },
        end: {
          line: 7,
          column: 74
        }
      },
      "2": {
        start: {
          line: 9,
          column: 20
        },
        end: {
          line: 9,
          column: 22
        }
      },
      "3": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 12,
          column: 3
        }
      },
      "4": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 91
        }
      },
      "5": {
        start: {
          line: 11,
          column: 72
        },
        end: {
          line: 11,
          column: 88
        }
      },
      "6": {
        start: {
          line: 14,
          column: 29
        },
        end: {
          line: 19,
          column: 3
        }
      },
      "7": {
        start: {
          line: 21,
          column: 28
        },
        end: {
          line: 21,
          column: 69
        }
      },
      "8": {
        start: {
          line: 22,
          column: 17
        },
        end: {
          line: 25,
          column: 14
        }
      },
      "9": {
        start: {
          line: 23,
          column: 18
        },
        end: {
          line: 23,
          column: 52
        }
      },
      "10": {
        start: {
          line: 26,
          column: 2
        },
        end: {
          line: 26,
          column: 53
        }
      },
      "11": {
        start: {
          line: 29,
          column: 20
        },
        end: {
          line: 29,
          column: 35
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 15
          },
          end: {
            line: 6,
            column: 16
          }
        },
        loc: {
          start: {
            line: 6,
            column: 61
          },
          end: {
            line: 27,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 11,
            column: 61
          },
          end: {
            line: 11,
            column: 62
          }
        },
        loc: {
          start: {
            line: 11,
            column: 72
          },
          end: {
            line: 11,
            column: 88
          }
        },
        line: 11
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 23,
            column: 9
          },
          end: {
            line: 23,
            column: 10
          }
        },
        loc: {
          start: {
            line: 23,
            column: 18
          },
          end: {
            line: 23,
            column: 52
          }
        },
        line: 23
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 10
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "fac013852322e93fc74e2aab37860136a9adb41c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1tny8dqku7 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1tny8dqku7();
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var IMGDROP_URL = (cov_1tny8dqku7().s[0]++, 'https://imgdrop.imgix.net');

// implementation of imgix-url filter for non-angular environment
function _default(imgixFileAndParams) {
  cov_1tny8dqku7().f[0]++;
  var _ref = (cov_1tny8dqku7().s[1]++, imgixFileAndParams.split('?')),
    _ref2 = _slicedToArray(_ref, 2),
    imgixFilename = _ref2[0],
    imgixParamsString = _ref2[1];
  var imgixParams = (cov_1tny8dqku7().s[2]++, {});
  cov_1tny8dqku7().s[3]++;
  if (imgixParamsString) {
    cov_1tny8dqku7().b[0][0]++;
    cov_1tny8dqku7().s[4]++;
    imgixParams = (0, _fromPairs2["default"])(imgixParamsString.split('&').map(function (param) {
      cov_1tny8dqku7().f[1]++;
      cov_1tny8dqku7().s[5]++;
      return param.split('=');
    }));
  } else {
    cov_1tny8dqku7().b[0][1]++;
  }
  var defaultImgixParams = (cov_1tny8dqku7().s[6]++, {
    auto: 'format,compress',
    // reduce size, increase page speed, use most efficient image format
    ch: 'Width,DPR',
    // client hinting, where available
    dpr: '2',
    // 2x display for retina screens by default,
    fit: 'max' // use the `w` and `h` params as maximums
  });
  var defaultsAndParams = (cov_1tny8dqku7().s[7]++, _objectSpread(_objectSpread({}, defaultImgixParams), imgixParams));
  var params = (cov_1tny8dqku7().s[8]++, Object.keys(defaultsAndParams).map(function (key) {
    cov_1tny8dqku7().f[2]++;
    cov_1tny8dqku7().s[9]++;
    return "".concat(key, "=").concat(defaultsAndParams[key]);
  }).sort().join('&'));
  cov_1tny8dqku7().s[10]++;
  return "".concat(IMGDROP_URL, "/").concat(imgixFilename, "?").concat(params);
}
var test = exports.test = (cov_1tny8dqku7().s[11]++, {
  IMGDROP_URL: IMGDROP_URL
});